const FooterLiterals = {
    privacyPolicy: {
        "en-GB": "Privacy Policy",
        "es-ES": "Política de Privacidad y Aviso Legal",
        "ca-ES": "Política de Privacitat i Avís Legal"
    },
    cookiePolicy: {
        "en-GB": "Cookie Policy",
        "es-ES": "Política de Cookies",
        "ca-ES": "Política de Cookies"
    },
    licensing: {
        "en-GB": "Licensing",
        "es-ES": "Licenciamiento",
        "ca-ES": "Llicenciament"
    },
    informationSecurityPolicy: {
        "en-GB": "Information Security Policy",
        "es-ES": "Política de Seguridad de la Información",
        "ca-ES": "Política de Seguretat de la Informació"
    },
    security: {
        "en-GB": "Security",
        "es-ES": "Seguridad",
        "ca-ES": "Seguretat"
    }
}

interface IFooterLiterals {
    privacyPolicy: string;
    cookiePolicy: string;
    licensing: string;
    informationSecurityPolicy: string;
    security: string;
}

export { FooterLiterals };
export type { IFooterLiterals };